import React, { useState } from 'react';
import CveList from './CveList';
import PodcastList from './PodcastList';
import { Form } from 'react-bootstrap';

const RightPanel = ({ profiles, path, cveFields = [] }) => {
  const [onlyKve, setOnlyKve] = useState(false);

  const toggle = () => {
    setOnlyKve((prev) => !prev);
  };

  return (
    <nav className='right-panel'>
      <Form.Label>Show Only KEVs</Form.Label>
      <Form.Check // prettier-ignore
        type='switch'
        onClick={toggle}
        data-testid='show-only-kevs-switcher'
      />

      <div className='pt-5'>
        {/* <div className='mb-5'>
          <PodcastList profile={profiles.podcasts} />
        </div> */}
        <div className='mb-5'>
          <CveList
            profile={profiles.cve}
            onlyKve={onlyKve}
            cveFields={cveFields}
          />
        </div>
      </div>
    </nav>
  );
};

export default RightPanel;
